<template>
  <div class="banner-container">
    <div class="wrapper content">
      <div class="banner-text">
        <img src="@/assets/images/home/logo.png" :alt="meeting_title" />
        <p>
          以为会员、行业和政府服务为根本宗旨，以推进汽车流通行业现代化建设为主要任务，
          进一步深化改革，开拓创新，加快发展，努力把协会建设成为一个服务功能强、社会联系广泛、
          国内外知名度较高，能够更好地发挥政府和企业桥梁与纽带作用的全国性汽车流通行业组织。
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { meeting_title } from '@/utils/constant'

export default defineComponent({
  setup() {
    return {
      meeting_title
    }
  }
})
</script>

<style scoped lang="scss">
.banner-container {
  width: 100%;
  height: 400px;
  background: url('../../assets/images/home/banner.png') no-repeat center;
  .content {
    color: #fff;
    font-size: 14px;
    position: relative;
    .banner-text {
      position: absolute;
      top: 120px;
      left: 0;
      width: 650px;
      img {
        width: 322px;
        height: 66px;
      }
      p {
        margin: 0px;
        margin-top: 37px;
        width: 650px;
        line-height: 24px;
      }
    }
  }
}
</style>
